import React, { Suspense } from 'react';

import { MarketingPreferences } from './components/MarketingPreferences';

import { ContactInformation } from 'js/app/components/main/UserDetails/components/ContactInformation';
import { VerifyDetails } from 'js/app/components/main/UserDetails/components/VerifyDetails';

import { componentService } from '@core/js/services/component.service';

import { DEFAULT_MARKETING_PRODUCTS } from '@interlayer/js/app/components/main/MarketingPreferences/constants';
import { USER_DETAILS } from '@interlayer/js/app/components/main/UserDetails/constants';

import style from './UserDetails.scss';

export const UserDetails = () => (
    <div className={style.container}>
        <ContactInformation />

        <VerifyDetails />

        <Suspense fallback="">
            <MarketingPreferences products={DEFAULT_MARKETING_PRODUCTS} tSuffix="userDetails." isAdditionalTextBlocks />
        </Suspense>
    </div>
);

// export default UserDetails;
componentService.registerPageComponents({ [USER_DETAILS]: UserDetails });
